module.exports = __webpack_public_path__ + "img/38a)Mövenpick Hotel Paris.jpg";